const styles = (theme) => ({
  actionBarContainer: {
    backgroundColor: theme.color.white,
    padding: theme.spacing(2.5),
    position: 'fixed',
    bottom: 0,

    '& .MuiGrid-item': {
      padding: theme.spacing(1.25),

      '& > .MuiButtonBase-root': {
        borderRadius: 5,
      },
    },
  },
  withMenu: {
    backgroundColor: theme.color.white,
    position: 'relative',

    '& .MuiGrid-item': {
      padding: theme.spacing(1.25),

      '& > .MuiButtonBase-root': {
        borderRadius: 5,
      },
    },
  },
});

export default styles;
